'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useRefinementList } from 'react-instantsearch';
const CategoryPageColorRestoration = t0 => {
  const $ = _c(8);
  const {
    colorIds: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const colorIds = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      attribute: "option_color",
      skipSuspense: true
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    items: colorFilters,
    refine
  } = useRefinementList(t3);
  const restoredSignatureRef = useRef("");
  let t4;
  let t5;
  if ($[3] !== colorFilters || $[4] !== colorIds || $[5] !== refine) {
    t4 = () => {
      if (colorFilters.length === 0) {
        return;
      }
      const desiredColorIds = new Set(colorIds.map(_temp));
      const signature = [...desiredColorIds].sort().join(",");
      if (signature === restoredSignatureRef.current) {
        return;
      }
      colorFilters.forEach(filter => {
        const filterLabel = filter.label ?? "";
        if (!filterLabel) {
          return;
        }
        const shouldBeRefined = desiredColorIds.has(filterLabel.toLowerCase());
        if (filter.isRefined !== shouldBeRefined) {
          refine(filterLabel);
        }
      });
      restoredSignatureRef.current = signature;
    };
    t5 = [colorIds, colorFilters, refine];
    $[3] = colorFilters;
    $[4] = colorIds;
    $[5] = refine;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  return null;
};
export default CategoryPageColorRestoration;
function _temp(colorId) {
  return colorId.toLowerCase();
}